import{useMemo as e}from"react";const o=()=>e((()=>"undefined"!=typeof window&&!!document.querySelector("#__next")),[]);export{o as useIsNextjsProject};